@switch (columnName) {
  @case ('actions') {
    @if (!element.isCancelled) {
      <app-ui-button
        appConfirmDialog
        appStopClickPropagation
        buttonType="icon-button"
        color="warn"
        icon="person_remove"
        [privilege]="Privileges.DocumentUpdate"
        tooltip="cancelReadReceiptRequest"
        confirmTitle="cancelReadReceiptRequest"
        [confirmEntityName]="element.name"
        confirmMessage="youAreCancellingReadReceiptForRevision"
        confirmButtonText="confirm"
        (confirmed)="cancelRequest()"
      ></app-ui-button>
    } @else {
      <div class="cancelled-placeholder">---</div>
    }
  }
  @case ('status') {
    {{ element.status | translate | titlecase }}
  }
  @case ('currentEmploymentDepartment') {
    {{ element.currentEmploymentDepartment?.name }}
  }
  @default {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
}
